"use strict";
import request from "@/utils/request";
const config = require("@/../config/config.json");

// This endpoint returns only the brands and outlets available to the login session.
export async function svc_fetchDashboardScopes() {
	return request(`${config.apiUrl}brands/search`, { method: "GET" });
}

/**
 * Fetches one dashboard widget from the API.
 * @param {string} widget Endpoint name: summary, daily, hourly, payments, channels, items or outlets.
 * @param {{from: string, to: string, brandId?: number, outletId?: number}} params Period and optional brand / outlet.
 * @returns {Promise<object|object[]|Response>} Widget data, or the failed response (request.js shows the error).
 * Business purpose: each dashboard card loads on its own from the sales roll-up endpoints.
 */
export async function svc_fetchDashboard(widget, params) {
	return request(`${config.apiUrl}reports/dashboard/${widget}`, {
		method: "GET",
		params,
	});
}
